import { loadView } from '@/router'

export default [
  {
    path: 'schedulepickups',
    name: 'manage-schedulepickups',
    component: loadView('Application/Manage/SchedulePickups'),
    showInAlfred: true,
    alfredTitle: 'Manage - Schedule Pickups'
  }
]
